const personDisplayName = ({ firstName, lastName, email, }) => (firstName && lastName ? `${firstName} ${lastName}` : email);

export { personDisplayName };
